<template>
  <div class="join-wrap">
    <div class="join-img">
      <!-- <p class="h1">{{$t('menu.job')}} <a href="#join"><i
            class="iconfont iconjob_offers"></i><span>{{$t('join.find')}}</span></a></p> -->
    </div>
    <!-- 公司介绍 -->
    <!--<ComInfo></ComInfo>-->
    <!-- 我们的核心价值观 -->
    <Core></Core>
    <!-- 我们的使命 -->
    <Mission></Mission>
    <!-- 招聘 -->
    <div id="join">
      <Join></Join>
    </div>
  </div>
</template>
<script>
import Core from "./component/core";
import ComInfo from "./component/com-info";
import Join from "./component/join";
import Mission from "./component/mission";
export default {
  components: { Core, ComInfo, Join, Mission }
};
</script>
<style lang="less" scoped>
@import "../../style/constant";

.join-wrap {
  background-color: #ffffff;
  width: 100%;

  .join-img {
    position: relative;
    height: 480px;
    background: url("../../../src/assets/back.jpg") center center no-repeat;
    background-size: cover;
    width: 100%;

    a {
      text-decoration: none;
      display: flex;
      align-items: center;
    }

    .iconjob_offers {
      font-size: 46px;
      color: #e76c5e;

      &:hover {
        cursor: pointer;
      }
    }

    .h1 {
      
      // background-color: hsla(0,0%,100%,.51);
      // padding: 30px;
      display: flex;
      flex-direction: column;
      position: absolute;
      font-size: 60px;
      color: @title-color;
      font-weight: 500;
      top: 30%;
      right: 15%;
      span {
        margin-left: 10px;
        color: #e76c5e;
        font-size: 14px;
      }
    }

  }
  @media screen and (max-width: 996px) {
  .join-img {
    height: 40vh;
    background: url("../../../src/assets/join-phone.png") center center no-repeat;
    background-size: cover;
    }
  }
}

@media screen and (max-width: 996px) {
  h2 {
    font-size: 25px !important;
  }
  .join-img {
    .h1 {
      font-size: 34px !important;
    }

    .iconjob_offers {
      font-size: 24px !important;
    }

    .bacImg {
      display: flex;
      align-items: center;
      height: 40vh !important;
      background-color: @from-icon-color !important;

      .title {
        color: #ffffff !important;
      }
    }
  }
}
</style>
